import type { BifrostWeb } from '@seekrtech/bifrost-web'
import type { Result } from '../types'

export interface L10nServiceMethods {
  getLocalizedString: (payload: {
    key: string
    params?: { type: 'integer' | 'float' | 'string'; value: string }[]
  }) => Promise<Result<string | null>>
}

export function createL10nService(bifrost: BifrostWeb): L10nServiceMethods {
  return bifrost.createNativeProxy<L10nServiceMethods>('L10nService')
}
